import { render, staticRenderFns } from "./Mobiles.vue?vue&type=template&id=23655758&scoped=true"
import script from "./Mobiles.vue?vue&type=script&lang=js"
export * from "./Mobiles.vue?vue&type=script&lang=js"
import style0 from "./Mobiles.vue?vue&type=style&index=0&id=23655758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23655758",
  null
  
)

export default component.exports